import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Realmente solo toma 10 minutos?',
  a: 'Sí. Son protocolos técnicos diseñados para la eficiencia, no para un retiro espiritual. Están basados en la estimulación directa del nervio vago para resultados inmediatos.'
}, {
  q: '¿Es otra suscripción mensual?',
  a: 'NO. Pagas una vez y el Ebook principal junto con los 5 bonos son tuyos para siempre. Sin cargos ocultos ni renovaciones.'
}, {
  q: '¿Necesito equipo especial?',
  a: 'Solo tus ojos, tus pulmones y este manual. Los protocolos utilizan la fisiología natural de tu cuerpo para regular tu sistema nervioso.'
}, {
  q: '¿Si no me funciona?',
  a: 'Tienes nuestra garantía de hierro de 7 días. Si no sientes resultados, te devolvemos el dinero y te quedas con el material.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-24 px-4 bg-[#0d0d12] border-t border-white/5" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-2xl bg-[#050507] overflow-hidden transition-colors hover:border-white/20" data-id="element-5">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-6">
                <span className="font-medium text-lg pr-8" data-id="element-7">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-8" />
              </button>

              <AnimatePresence data-id="element-9">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-10">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-11">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}